import React from 'react';

import './toolbar.scss';

type Props = { pairs: number; guesses: number; restartGame: () => void };

class Toolbar extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.restartGame();
  }

  render() {
    return (
      <div className="toolbar">
        <div className="toolbar-counter">
          <div className="toolbar-counter-container">
            <span className="toolbar-counter-value">{this.props.guesses}</span>
            <span className="toolbar-counter-legend">{this.props.guesses > 1 ? 'guesses' : 'guess'}</span>
          </div>
          <div className="toolbar-counter-container">
            <span className="toolbar-counter-value">{this.props.pairs}</span>
            <span className="toolbar-counter-legend">/8 pairs</span>
          </div>
        </div>
        <button className="toolbar-button" type="button" onClick={this.handleClick}>
          Restart
        </button>
      </div>
    );
  }
}

export default Toolbar;
